import { c as _c } from "react/compiler-runtime";
import { SalesChartEmptyState } from "./SalesChartEmptyState";
export function SalesChartErrorState(t0) {
  const $ = _c(11);
  let overrides;
  let rest;
  if ($[0] !== t0) {
    ({
      overrides,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = overrides;
    $[2] = rest;
  } else {
    overrides = $[1];
    rest = $[2];
  }
  const t1 = overrides?.EmptyState;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1,
      variant: "no-data"
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== overrides || $[6] !== t2) {
    t3 = {
      ...overrides,
      EmptyState: t2
    };
    $[5] = overrides;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== rest || $[9] !== t3) {
    t4 = <SalesChartEmptyState {...rest} overrides={t3} />;
    $[8] = rest;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}